import { FormatConstant, LangConstant, SystemConstant } from "const";
import { getInteractor } from "services/local.service";
import { convertString2JSON, FileUtil, getDataFromPrefixKey, getExternalLinkFromString, toCamel } from "utils";
import { convertTimeStampToDate } from "utils/date.utils";
import { getNSLang } from "utils/lang.utils";
import { getMetaDataFile } from "utils/message.utils";

/**
 *
 * @param {string} prefixKey
 * @param {array} fileList : records in file-group table union message table
 * @returns
 */
export const refactorFiles = async (prefixKey, fileList) => {
  const [accountId, branchId] = getDataFromPrefixKey(prefixKey);
  const jsonAccounts = {};
  const displayFileList = [];

  // Refactor fileRecord to data that is displayed
  for (let index = 0; index < fileList.length; index++) {
    const recordItem = fileList[index];
    const fileData = convertString2JSON(recordItem.fileData, {}, true);
    const fileMetaData = toCamel(fileData.meta_data || {});

    if (recordItem.createdByAccountId && !jsonAccounts[recordItem.createdByAccountId]) {
      const createdByAccount = await getInteractor(prefixKey).LocalAccountService.get(
        recordItem.createdByAccountId,
        branchId,
      );

      jsonAccounts[recordItem.createdByAccountId] = toCamel(createdByAccount);
    }

    const createdByAccount = jsonAccounts[recordItem.createdByAccountId] || {};
    const senderName = createdByAccount.contactName || createdByAccount.name || createdByAccount.phone || "";

    const isLink = recordItem.fileType === SystemConstant.FILE_TYPE.LINK;
    if (isLink) {
      const lastChildMessage = (
        await getInteractor(prefixKey).LocalMessageService.getChildMessages(recordItem.sourceMessageId, [
          SystemConstant.SEND_TYPE.groupMessage,
          SystemConstant.SEND_TYPE.message,
          SystemConstant.SEND_TYPE.link,
          SystemConstant.SEND_TYPE.quote,
        ])
      )[0];

      const links = getExternalLinkFromString(lastChildMessage?.content || recordItem.fileName); // recordItem.fileName = messageContent if recordItem is link

      links.forEach(link => {
        const linkUrl = new URL(link);
        const hostname = linkUrl.hostname;
        displayFileList.push({
          ...recordItem,
          content: link,
          url: "",
          attachmentId: "",
          metaData: {},
          senderName: senderName,
          senderAvatarId: createdByAccount.avatarId,
          description: hostname,
          createdDate: convertTimeStampToDate(recordItem.created / 1000, FormatConstant.FM_DD_MM_YYYY),
        });
      });
    } else if (recordItem.fileId) {
      const file = await getInteractor(prefixKey).LocalFileService.findOne({ id: recordItem.fileId });

      const shareByContent = getNSLang(
        LangConstant.NS_MANAGE_FILE,
        accountId === recordItem.createdByAccountId ? "FM_SHARE_BY_ME" : "FM_SHARE_BY_OTHER",
        {
          fileSize: FileUtil.convertFileSizeUnit(fileMetaData.size || 0),
          name: senderName,
        },
      );

      displayFileList.push({
        ...recordItem,
        content: recordItem.fileName,
        url: file?.url,
        attachmentId: recordItem.fileId,
        metaData: {
          ...getMetaDataFile(recordItem.sourceMessageId, toCamel(fileData)),
          ...fileMetaData,
        },
        senderName: senderName,
        senderAvatarId: createdByAccount.avatarId,
        description: shareByContent,
        createdDate: convertTimeStampToDate(recordItem.created / 1000, FormatConstant.FM_DD_MM_YYYY),
      });
    }
  }

  return displayFileList;
};
